// extracted by mini-css-extract-plugin
export default {"inputBox":"InputDesign_inputBox__XrnxQ"};